"use strict";

exports.__esModule = true;
exports.default = setLocale;
var _locale = _interopRequireDefault(require("./locale"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function setLocale(custom) {
  Object.keys(custom).forEach(function (type) {
    // @ts-ignore
    Object.keys(custom[type]).forEach(function (method) {
      // @ts-ignore
      _locale.default[type][method] = custom[type][method];
    });
  });
}